import React, { useState, useEffect } from 'react';
import ReactTooltip from 'react-tooltip';
import Rodal from 'rodal';
import moment from 'moment';
import { Link } from 'react-router-dom';

import {
  ANALYTICS_CATEGORIES,
  ANALYTICS_ACTIONS,
  sendEvent,
} from '../../../components/analytics';

import './style.scss';

const heartEmpty = require('../../../assets/icons/heart-empty.png');
const heartFilled = require('../../../assets/icons/heart-filled.png');
const iWillVoteLogo = require('../../../assets/icons/iwillvote.png');

const ElectionInfo = (props) => {
  const {
    elections,
    getAllElections,
    history,
    isLoggedIn,
    match: {
      params: {
        id: electionId,
      },
    },
    removeElectionFromUser,
    saveElectionToUser,
    selectedElection,
    setSelectedElection,
    setSelectedRace,
    setUserAddress,
    setUserSeenAddressPrompt,
    user,
    userQueriedAddress,
    userSavedElections,
    userSeenAddressPrompt,
  } = props;

  const [modalVisible, setModalVisible] = useState(false);
  const [userSavedThisElection, setUserSavedThisElection] = useState(userSavedElections.includes(electionId));

  useEffect(() => {
    if (elections.length === 0) {
      getAllElections();
    }
  }, [elections]);

  useEffect(() => {
    setSelectedElection(electionId);
  }, [elections, electionId]);

  useEffect(() => {
    if (isLoggedIn && userQueriedAddress && user.street_address !== userQueriedAddress && !userSeenAddressPrompt) {
      setModalVisible(true);
    }
  }, [isLoggedIn, userQueriedAddress]);

  useEffect(() => {
    setUserSavedThisElection(userSavedElections.includes(electionId));
  }, [userSavedElections]);

  if (!selectedElection) {
    return <p>Election not found</p>;
  }

  const handleHeartClick = () => {
    if (isLoggedIn) {
      setUserSavedThisElection(!userSavedThisElection);

      if (userSavedThisElection) removeElectionFromUser(electionId);
      else saveElectionToUser(electionId);
    }
  };

  const handleSaveAddressClick = () => {
    setUserAddress(userQueriedAddress);
    setModalVisible(false);
  };

  return (
    <div id="elections-content">
      <div id="save-election-container">
        {isLoggedIn && (
        <div id="dummy-filler" />
        )}
        <h1>{selectedElection.title}</h1>
        {isLoggedIn && (
          <img
            alt="heart icon"
            data-tip={userSavedThisElection ? 'Click to unsave this election' : 'Click to save this election'}
            onClick={handleHeartClick}
            src={userSavedThisElection ? heartFilled : heartEmpty}
          />
        )}
      </div>
      <h3>{moment(selectedElection.date).format('MMMM Do, YYYY')}</h3>
      <div id="races-container">
        {selectedElection.races.map((race) => {
          const {
            title,
            _id: id,
          } = race;

          return (
            <div className="race"
              key={id}
              onClick={() => {
                sendEvent(ANALYTICS_CATEGORIES.RACES, ANALYTICS_ACTIONS.SET);
                setSelectedRace(id);
                history.push(`/race/${id}`);
              }}
            >
              {title}
            </div>
          );
        })}
      </div>
      <div id="iwillvote-container">
        <img src={iWillVoteLogo} alt="I Will Vote Logo" />
        <div>
          <h3>Register to vote and find polling locations at:</h3>
          <a href={`https://iwillvote.com/${selectedElection.state}`} target="_blank" rel="noopener noreferrer">www.iwillvote.com/{selectedElection.state}</a>
        </div>
      </div>
      <div id="iwillvote-container">
        <div>
          <Link to={`/turnout/${selectedElection.state}`}> Or check out past election turnout data in {selectedElection.state} here </Link>
        </div>
      </div>
      <div className="separator-line" />
      <div id="add-container">
        <h3>Know a race on the ballot for the {selectedElection.title} that is not reported here?</h3>
        <p>Help us improve our application by providing information on it.</p>
        <button id="add-race-button" type="button" onClick={() => history.push(`/race/new?electionId=${electionId}`)}>Add Race to Election</button>
      </div>
      {/* this fixes a bug where deeplink load renders a black line */}
      <div data-tip="" />
      <ReactTooltip />
      <Rodal visible={modalVisible} onClose={() => setModalVisible(false) || setUserSeenAddressPrompt(true)}>
        <div id="modal-save-address-content">
          <h2>Save this address to your account?</h2>
          <p>We&apos;ll use it to auto-find future elections for you.</p>
          <p>This will override any previously stored address.</p>
          <p id="address">{userQueriedAddress}</p>
          <div id="button-container">
            <button type="button" onClick={handleSaveAddressClick}>
              Save Address
            </button>
            <button type="button" onClick={() => setModalVisible(false) || setUserSeenAddressPrompt(true)}>
              No Thanks
            </button>
          </div>
        </div>
      </Rodal>
    </div>
  );
};

export default ElectionInfo;
